import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "I've been using Rohan Tax Service for the past 3 years and I'm extremely satisfied with their service. No complaints whatsoever! Their team is very supportive, professional, and efficient. Highly recommended!",
    author: "Dhananjay Shukla",
  },
  {
    quote:
      "Really amazing service in terms of gst filing , income tax filing as well the experience of nilesh sir is superb and Nilesh sir always give very genuine advice to their clients",
    author: "Dhruv Thakkar",
  },
  {
    quote:
      "Excellent service! Rohan's Tax Services (Nilesh Gajjar) really knows expert accounting. The highest quality GST - Income Tax Accounting service I’ve ever come across..since last 13 years..! Best Wishes from Vinayak Construction Equipments.",
    author: "Viral Jolapara",
  },
  {
    quote:
      "Work was excellent and execution intimee to help customers satisfaction.  Good work with the friendly staffs.",
    author: "Akshay Shah",
  },
  {
    quote:
      "Your work speaks volumes of the kind of man you are – efficient, organized and result-oriented",
    author: "Rajesh Kumar Nawandhar",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="py-20 px-4 md:px-6 lg:px-8 bg-gray-50 bg-cover bg-center relative"
      style={{
        backgroundImage:
          "url('https://i.pinimg.com/736x/5c/96/dd/5c96dd00ce8abf877d4892e6c807da32.jpg')",
      }}
    >
      {/* Overlay for better text visibility */}
      <div className="absolute inset-0 bg-black opacity-40"></div>

      <div className="max-w-6xl mx-auto rounded-lg relative z-10">
        <h2 className="text-3xl font-bold mb-2 text-center text-white">
          Client{" "}
          <span className="text-[#151C62] border-b-2 border-[#151C62] pb-1">
            {" "}
            Testimonials
          </span>
        </h2>
        '
        <h4 className="text-white text-lg mb-12 text-center">
          At Rohan's Tax Services, we’re more than just tax advisors—we’re your
          trusted partner in managing finances, guiding you through complex tax
          landscapes for long-term success.
        </h4>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          loop
          autoplay={{ delay: 3000 }}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index} className="mb-20">
              <div className="min-w-[300px] rounded-lg max-w-sm mx-auto h-64 border overflow-hidden shadow-lg bg-white p-6 flex flex-col justify-between">
                <Quote className="h-8 w-8 text-primary mb-4" />
                <p className="mb-4 italic line-clamp-4">{testimonial.quote}</p>
                <div>
                  <p className="font-semibold text-[#151C62]">
                    {testimonial.author}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
